;(function(){
	function initBlock(root){
		if(!root) return;
		const slides = Array.from(root.querySelectorAll('.yantis-slide'));
		const corners = Array.from(root.querySelectorAll('.yantis-corner'));
		const rotor = root.querySelector('.yantis-rotor');
		const left = root.querySelector('.yantis-left');
		const prevBtn = root.querySelector('.yantis-prev');
		const nextBtn = root.querySelector('.yantis-next');
		const total = slides.length;
		let index = 0;

		function setActive(newIndex){
			if(total === 0) return;
			index = (newIndex + total) % total;
			slides.forEach((s,i)=>{
				s.classList.toggle('is-active', i === index);
			});
			corners.forEach((c,i)=>{
				c.classList.toggle('is-active', i === index);
			});
			if(rotor){
				rotor.style.setProperty('--yantis-rotation', (index * 90) + 'deg');
			}
		}

		corners.forEach(btn=>{
			btn.addEventListener('click', ()=>{
				const i = parseInt(btn.getAttribute('data-index')||'0',10);
				setActive(i);
			});
		});

		if(prevBtn){
			prevBtn.addEventListener('click', ()=> setActive(index-1));
		}
		if(nextBtn){
			nextBtn.addEventListener('click', ()=> setActive(index+1));
		}

		// Set min-height based on tallest slide to prevent jumping
		if(left && slides.length > 0){
			// Use requestAnimationFrame to ensure DOM is ready
			requestAnimationFrame(() => {
				let maxHeight = 0;
				slides.forEach(slide => {
					// Temporarily make visible to measure
					const originalClasses = slide.className;
					slide.style.cssText = 'position: relative !important; visibility: visible !important; opacity: 1 !important; height: auto !important;';
					const height = slide.offsetHeight;
					if(height > maxHeight) maxHeight = height;
					// Restore original state
					slide.style.cssText = '';
					slide.className = originalClasses;
				});
				if(maxHeight > 0){
					left.style.minHeight = maxHeight + 'px';
					left.style.transition = 'min-height 0.3s ease';
				}
			});
		}

		setActive(0);
	}

	function onReady(){
		const blocks = document.querySelectorAll('.why-choose-yantis');
		blocks.forEach(initBlock);
	}

	if(document.readyState === 'loading'){
		document.addEventListener('DOMContentLoaded', onReady);
	}else{
		onReady();
	}
})();


